import React from "react";
import styled from "styled-components";

interface FormHeadingStyledProps {
	color?: string;
	margin?: string;
}

export const FormHeadingStyled = styled.h2<FormHeadingStyledProps>`
	margin: ${(props) => (props.margin ? props.margin : "0 0 1.75rem 0")};
	font-size: ${(props) => (props.theme as any).fontSizes.xxl};
	color: ${(props) => props.color};
	font-family: "roboto";
`;

interface FormHeadingProps {
	color?: string;
	margin?: string;
	text: string;
}

export const FormHeading: React.FC<FormHeadingProps> = ({ color, text, margin }) => {
	return (
		<FormHeadingStyled color={color} margin={margin}>
			<div className="text-[18px] font-semibold text-primary-900">{text}</div>
		</FormHeadingStyled>
	);
};
